/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSelector } from "react-redux";
import { RootState } from "app/store";

import StyledFooter from "./styled-components/StyledFooter";
import StyledMainContent from "./styled-components/StyledMainContent";
import LogoWhite from "common/svg/LogoWhite";
import StyledList from "./styled-components/StyledList";

function Footer() {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );
  const upTabletScreen = useSelector(
    (state: RootState) => state.app.upTabletScreen
  );
  return (
    <StyledFooter>
      {!upTabletScreen && (
        <p className="call-us">
          Llámanos gratis: <a href="tel:900670707">900 67 07 07</a>
        </p>
      )}
      <StyledMainContent>
        <LogoWhite width={80} />
        <StyledList>
          {!upDesktopScreen ? (
            <>
              <li>
                <a href="">Política de privacidad</a>
              </li>
              <li>
                <a href="">Avisos legales</a>
              </li>
              <li>
                <a href="">Uso de cookies</a>
              </li>
              <li>
                <a href="">Política de privacidad</a>
              </li>
              <li>
                <a href="">Avisos legales</a>
              </li>
              <li>
                <a href="">Uso de cookies</a>
              </li>
            </>
          ) : (
            <>
              <li>
                <a href="">Politica de privacidad</a>
              </li>
              <div className="list-separator"></div>
              <li>
                <a href="">Avisos legales</a>
              </li>
              <div className="list-separator"></div>
              <li>
                <a href="">Uso de cookies</a>
              </li>
              <div className="list-separator"></div>
              <li>
                <a href="">Condiciones Generales de Contratación</a>
              </li>
            </>
          )}
        </StyledList>
      </StyledMainContent>
      <p className="copyright">
        Copyright &copy; 2020 Digien SL. Reservados todos los derechos.
      </p>
    </StyledFooter>
  );
}

export default Footer;
